import React from "react";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { CommonProps } from "@utils/interface";
import { resolvePath } from "@utils/resolvePath";
import CloneChildren from "@components/children";
import CircleTick from "@public/images/icons/circle-tick.svg";
import {
  CardContainer,
  TopSection,
  BackgroundImage,
  ContentWrapper,
  Title,
  PriceLabel,
  PriceValue,
  SelectButton,
  BottomSection,
  HighlightsTitle,
  HighlightItem,
  SeeHowItWorks,
  PriceContainer,
  CircleTickIcon
} from "./styles";

export interface IActivationSelectionCard extends CommonProps {
  title?: string;
  price?: string;
  ctaText?: string;
  backgroundImageSrc?: string;
  highlights?: string[];
  seeHowText?: string;
  actions?: any;
  highlightsText?: string;
}

const mapStateToProps = (state: any, ownProps: any) => ({
  is_visible: getWidgetSpecificIsVisible(
    state.configuration?.normalisedConfig,
    ownProps.id
  )
});

const ActivationSelectionCard = ({
  children,
  ...props
}: IActivationSelectionCard) => {
  const {
    id,
    is_visible,
    title,
    price,
    ctaText,
    backgroundImageSrc,
    highlights = [],
    seeHowText,
    actions,
    highlightsText
  } = props;

  const { on_click, on_see_how_it_works_click } = actions || {};

  const handleClick = () => {
    if (on_click?.length > 0) {
        on_click.forEach((each: any) => {
        each.funCall(each.args);
      });
    }
  };
  
  const handleSeeHowItWorksClick = () => {
    if (on_see_how_it_works_click?.length > 0) {
      on_see_how_it_works_click.forEach((each: any) => {
        each.funCall(each.args);
      });
    }
  };

  return (id && is_visible) || !id ? (
    <CardContainer>
      <TopSection>
        <BackgroundImage
          backgroundImage={
            backgroundImageSrc ? resolvePath(backgroundImageSrc) : undefined
          }
        />

        <ContentWrapper>
          <Title>{title}</Title>
          <PriceContainer>
            <div>
              <PriceLabel>Price</PriceLabel>
              <PriceValue>₹{price}</PriceValue>
            </div>

            <SelectButton onClick={handleClick}>{ctaText}</SelectButton>
          </PriceContainer>
        </ContentWrapper>
      </TopSection>

      <BottomSection>
        <HighlightsTitle>✦ {highlightsText}</HighlightsTitle>

        {highlights.map((item, index) => (
          <HighlightItem key={index}>
            <CircleTickIcon>
              <CircleTick />
            </CircleTickIcon>
            {item}
          </HighlightItem>
        ))}

        {seeHowText && <SeeHowItWorks onClick={handleSeeHowItWorksClick}>{seeHowText} →</SeeHowItWorks>}
      </BottomSection>

      {children && <CloneChildren>{children}</CloneChildren>}
    </CardContainer>
  ) : null;
};

export default connect(mapStateToProps)(ActivationSelectionCard);
